import CheckAuthorization from '../StatusPages/CheckAuthorization';
import { AddProperty } from './AddProperty';

const AddPropertyCheckAuth = () => (
    <CheckAuthorization>
        <AddProperty />
    </CheckAuthorization>
);
export default AddPropertyCheckAuth;
